import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      padding: spacing.s,
      borderRadius: constants.radius.view,
    },
    inner: {
      flex: 1,
    },
    date: {
      opacity: 0,
      position: "absolute",
    },
    disabled: {
      opacity: 0.5,
    },
    input: {
      all: "unset",
      fontSize: 16,
      fontWeight: 500,
      fontFamily: `"Inter", sans-serif`,
      flexGrow: 1,
      color: theme.input.text,
    },
    divider: {
      color: theme.input.text,
    },
    year: {
      marginRight: spacing.s,
      width: "25%",
    },
    month: {
      marginRight: spacing.s,
      width: "40%",
    },
  };

  return styles;
};
